import { pharmacyUpsertModalRouteStore } from '../components/pharmacy-upsert-modal/domain/store';

export default (showing = true) => {
  pharmacyUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
